<template>
    <section v-if="data && ( (loadingPostsStatus === 'success' && postItems.length) || loadingPostsStatus === 'loading' )" class="container module-posts container--large margin-both-lg">
        <h2 v-if="data.title" class="modle-title">{{data.title}}</h2>
        <div class="post-blocks-row" v-if="loadingPostsStatus === 'success' && postItems && postItems.length">
            <PostBlock v-for="(post,i) in postItems" :data="post" :key="post.id"/>
        </div>
        <div class="archive-link">
            <router-link class="arrowed-link" :to="archiveLink"><span class="txt">{{archiveLinkText}}</span><span class="icon" v-html="arrowIcon" /></router-link>
        </div>
    </section>
</template>

<script>
import DummyLine from '@/components/elements/DummyLine'
import PostBlock from '@/components/elements/PostBlock'
import { mapActions } from 'vuex'
import { arrow } from '@/components/../icons';

export default {
    name: 'posts-module',
    props: ['data'],
    data(){
        return {
            archiveLink : '/',
            archiveLinkText : 'Se alle artikler',
            postItems: [],
            loadingPostsStatus: 'loading',
        }
    },
    mounted(){
        const VM = this;
        if(!VM.data) return false;
        VM.archiveSettings()
        VM.loadingPostsStatus = 'loading'
        VM.getPost(VM.loadOpt).then(res=>{
            if(res.data && res.data.posts && res.data.posts.length){
                //console.log(res.data.posts)
                VM.loadingPostsStatus = 'success'
                VM.postItems = res.data.posts
            }else{
                VM.loadingPostsStatus = 'notFound'  
            }
        })
    },
    computed:{
        arrowIcon(){
            return arrow('#00344D')
        },
        loadOpt(){
            const VM = this;
            if(!VM.data) return [];
            const opt = {
                type: VM.data.type || 'post',
                exclude: VM.data.exclude || 0,
                limit : VM.data.limit || 3,
                tags : VM.data.category || 0,
                taxonomy : VM.data.taxonomy || 'category'
            }

            return opt;
        }
    },
    components:{
        DummyLine,
        PostBlock
    },
    methods:{
		...mapActions([
			'getPost',
        ]),
        archiveSettings(){
            const postType = this.data.type || 'post'
            switch (postType) {
                case 'post':
                    this.archiveLink = '/'+window.WPVUE.blog_base.slug
                    break;
                case 'professions':
                    this.archiveLinkText = 'Yrker'
                    this.archiveLink = '/'+window.WPVUE.options.archive_professions.slug
                    break;
                case 'educations':
                    this.archiveLinkText = 'Utdanninger'
                    this.archiveLink = '/'+window.WPVUE.options.archive_educations.slug
                    break;
                case 'ambassadors':
                    this.archiveLinkText = 'Ambassadører'
                    this.archiveLink = '/'+window.WPVUE.options.archive_ambassadors.slug
                    break;
                case 'teachers':
                    this.archiveLinkText = 'Se alt innhold'
                    this.archiveLink = '/'+window.WPVUE.options.archive_teachers.slug
                    break;
            }
        },
    }
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

.module-posts{
    .post-blocks-row{
        justify-content: center;
    }
    .modle-title{
        text-align: center;
        margin-top: 0;
        margin-bottom: 25px;
    }
}

</style>